import type { ReferenceListItem } from "../../types/reference-list.types";
import type { EnumValueDto, EquipmentDto } from "@/lib/api";

/** Undefined without an id; such an item can't be referenced by a vehicle. */
export function toReferenceListItem(
	item: EnumValueDto | EquipmentDto | undefined
): ReferenceListItem | undefined {
	return item?.enumId
		? { id: item.enumId, label: item.description || item.enumId }
		: undefined;
}

/** Drops items without an id; they can't be referenced by a vehicle. */
export function toReferenceListItems(
	items: Array<EnumValueDto | EquipmentDto>
): Array<ReferenceListItem> {
	return items.flatMap((item) => toReferenceListItem(item) ?? []);
}
